import React from 'react';
import './Footer.css';
import { FaTwitter, FaLinkedin } from 'react-icons/fa';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="footer-container">
      <div className="footer-main">
        <div className="footer-column footer-about">
          <h3>Chendur Vishakan Bio Energy (P) Ltd</h3>
          <p>“Fueling Progress with Green Power.”</p>
        </div>
        <div className="footer-column footer-links">
          <h4>Quick Links</h4>
          <ul>
            <li><Link to="/">Home</Link></li>
            <li><Link to="/#about">About</Link></li>
            <li><Link to="/services">Services</Link></li>
            <li><Link to="/#products">Products</Link></li>
            <li><Link to="/technology-innovation">Technology & Innovation</Link></li>
            <li><Link to="/#contact">Contact</Link></li>
          </ul>
        </div>
        <div className="footer-column footer-social">
          <h4>Connect With Us</h4>
          <div className="social-icons">
            <a href="https://twitter.com/" target="_blank" rel="noopener noreferrer" aria-label="Twitter">
              <FaTwitter />
            </a>
            <a href="https://www.linkedin.com/" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">
              <FaLinkedin />
            </a>
          </div>
        </div>
      </div>
      <div className="footer-bottom">
        <p>&copy; 2025 Chendur Vishakan Bio Energy (P) Ltd.</p>
      </div>
    </footer>
  );
};

export default Footer;